import clsx from 'clsx';
import { ReactElement } from 'react';
import { Content } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { TooltipPopover } from 'src/core/ui';
import { CheckIcon, IconsFill, WarningOutlineIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import {
  DateTimeRangeWithRelative,
  EventTimeFrameFilter,
} from 'src/WebApiController';

import * as styles from './DateRangePresets/DateRangePresets.css';

interface EventDateModeProps {
  eventTimeFrame?: EventTimeFrameFilter | null;
  onTimeFrameSelect: (timeFrame: EventTimeFrameFilter | null) => void;
  disabled?: boolean;
  value?: DateTimeRangeWithRelative | null;
  includePast?: boolean;
}

export const EventDateMode = ({
  eventTimeFrame,
  onTimeFrameSelect,
  disabled,
  value,
  includePast = true,
}: EventDateModeProps): ReactElement => {
  const timeFrameOptions = [
    { value: EventTimeFrameFilter.Future, label: ContentId.FutureEvents },
    ...(includePast
      ? [{ value: EventTimeFrameFilter.Past, label: ContentId.PastEvents }]
      : []),
  ];

  const isAllEventsSelected =
    eventTimeFrame === null &&
    (value === null ||
      (value?.relativeEndSecs === null &&
        value?.relativeStartSecs === null &&
        value?.start === null &&
        value?.end === null));

  return (
    <div>
      {timeFrameOptions.map((option, index) => {
        const isSelected = eventTimeFrame === option.value;
        return (
          <div
            className={styles.suggestionContainerV2}
            key={index}
            onClick={() => onTimeFrameSelect(option.value)}
          >
            <button
              className={clsx(styles.suggestionV2, {
                [styles.suggestionSelected]: isSelected,
              })}
              disabled={disabled}
            >
              <span className={styles.suggestionText}>
                <Content id={option.label} />
              </span>
              <TooltipPopover
                triggerContent={
                  <WarningOutlineIcon fill={IconsFill.textWarning} />
                }
              >
                <Content id={ContentId.TooManyResultPerformanceWarning} />
              </TooltipPopover>
            </button>
            {isSelected && (
              <CheckIcon
                className={styles.checkIconV2}
                size={vars.iconSize.s}
                fill={IconsFill.textSuccess}
              />
            )}
          </div>
        );
      })}
      <div
        className={styles.suggestionContainerV2}
        onClick={() => onTimeFrameSelect(null)}
      >
        <button
          className={clsx(styles.suggestionV2, {
            [styles.suggestionSelected]: isAllEventsSelected,
          })}
          disabled={disabled}
        >
          <span className={styles.suggestionText}>
            <Content id={ContentId.AllEvents} />
          </span>
          <TooltipPopover
            triggerContent={<WarningOutlineIcon fill={IconsFill.textWarning} />}
          >
            <Content id={ContentId.TooManyResultPerformanceWarning} />
          </TooltipPopover>
        </button>
        {isAllEventsSelected && (
          <CheckIcon
            className={styles.checkIconV2}
            size={vars.iconSize.s}
            fill={IconsFill.textSuccess}
          />
        )}
      </div>
    </div>
  );
};
